import { get, post, put, del } from './http'

export default { get, post, put, del }
